


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ImagePreview from "../image/image-preview.vue";
import ComponentItem from "./component-item.vue";

@Component({
  components: { ImagePreview, ComponentItem }
})
export default class Collapse extends Vue {
  itActive = -1;
  itActiveList: number[] = [];
  @Prop({ default: null, type: Array })
  items: any;

  @Prop({ default: null, type: String })
  hkey: any;

  @Watch("hkey")
  onChildChanged(current: any, pre: any) {
    // this.itActiveList = current === "installation" ? [0, 1] : [];
    this.itActiveList = [];
  }

  parseMessage(val: string | string[]) {
    return typeof val === "string"
      ? `<p>${val}</p>`
      : []
          .concat(val as any)
          .reduce(
            (pre: string, current: string) => `${pre}<li>${current}</li>`,
            '<ol type="a" class="qs-text-info">'
          ) + "</ol>";
  }

  isString(val: string) {
    return typeof val === "string";
  }
  get isActive() {
    return true;
  }
  isArray(val: any) {
    return Array.isArray(val);
  }
  isObject(val: any) {
    const type = typeof val;
    return val != null && (type === "object" || type === "function");
  }
  toggle(idx: number) {
    const tmp = [...this.itActiveList];
    this.itActive = idx === this.itActive ? -1 : idx;
    const ix = tmp.indexOf(idx);
    if (~ix) {
      tmp.splice(ix, 1);
    } else {
      tmp.push(idx);
    }
    this.itActiveList = tmp;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collapse/collapse.vue